import { defineElement } from '@webtides/element-js';
import InputField from '../input-field/input-field';
import InputEvents from '../../../../legacy-library/webcomponents/_form/events/InputEvents';

export default class InputRepeatField extends InputField {
    _repeatValid = true;

    get isValid() {
        return super.isValid && this._repeatValid;
    }

    properties() {
        return Object.assign(super.properties(), {
            repeatedName: null,
        });
    }

    events() {
        return Object.assign(super.events(), {
            this: {
                [InputEvents.INPUT_CHANGE]: () => {
                    if (this.repeatedName) {
                        const element = document.querySelector(`[name="${this.repeatedName}"]`);

                        if (element.value !== this.value) {
                            this._repeatValid = false;
                        } else {
                            this._repeatValid = true;
                        }
                    }
                },
            },
        });
    }
}

defineElement('input-repeat-field', InputRepeatField);
